import { render } from "./insurance_claims.html?vue&type=template&id=3ee9730b&external"
import script from "./insurance_claims.js?vue&type=script&lang=js&external"
export * from "./insurance_claims.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__